import image from "../assets/images/image.png";
import Cushion from "../assets/images/Cushion.png";
import Cushion2 from "../assets/images/Cushion2.png";
import Cushion3 from "../assets/images/Cushion3.png";
import carpet from "../assets/images/carpet.png";
import carpet2 from "../assets/images/carpet2.png";

const ProductsData = [
 {
    id: 1,
    name: "Nazakat Hand Woven Beige Cotton Cushion Cover",
    size: "30x45 cm",
    price: 4000,
    oldPrice: 8000,
    image: image
  },
  {
    id: 2,
    name: "Elegant Cushion Cover",
    size: "30x45 cm",
    price: 3500,
    oldPrice: 7000,
    image: Cushion
  },
  {
    id: 3,
    name: "Modern Cushion Cover",
    size: "30x45 cm",
    price: 4200,
    oldPrice: 9000,
    image: Cushion2
  },
  {
    id: 4,
    name: "Nazakat Hand Woven Beige Cotton Cushion Cover",
    size: "30x45 cm",
    price: 4000,
    oldPrice: 8000,
    image: Cushion3
  },
  {
    id: 5,
    name: "Elegant Cushion Cover",
    size: "30x45 cm",
    price: 3500,
    oldPrice: 7000,
    image: carpet
  },
  {
    id: 6,
    name: "Modern Cushion Cover",
    size: "30x45 cm",
    price: 4200,
    oldPrice: 9000,
    image: carpet2
  },
   {
    id: 7,
    name: "Nazakat Hand Woven Beige Cotton Cushion Cover",
    size: "30x45 cm",
    price: 4000,
    oldPrice: 8000,
    image: image
  },
  {
    id: 8,
    name: "Elegant Cushion Cover",
    size: "30x45 cm",
    price: 3500,
    oldPrice: 7000,
    image: Cushion
  }
 
];


export default ProductsData;